import * as yup from 'yup';

export const radiusFormSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido'),
  hostname: yup.string().required('El campo hostname es requerido'),
  password: yup.string().required('El campo password es requerido'),
  direccion: yup.string().required('El campo dirección es requerido'),
  coordenadas: yup.string().required('El campo coordenadas es requerido'),
});
